/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PlotInputs */

const en_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plot`)
};

const es_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcela`)
};

const fr_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcelle`)
};

const de_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundstück`)
};

const ja_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敷地・土地`)
};

const zh_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地块`)
};

const ar_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قطعة أرض`)
};

const id_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petak`)
};

const it_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terreno`)
};

const ru_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Земельный участок`)
};

const pt_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lote / Terreno`)
};

const ko_val_plot = /** @type {(inputs: Val_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토지`)
};

/**
* | output |
* | --- |
* | "Plot" |
*
* @param {Val_PlotInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_plot = /** @type {((inputs?: Val_PlotInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PlotInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_plot(inputs)
	if (locale === "es") return es_val_plot(inputs)
	if (locale === "fr") return fr_val_plot(inputs)
	if (locale === "de") return de_val_plot(inputs)
	if (locale === "ja") return ja_val_plot(inputs)
	if (locale === "zh") return zh_val_plot(inputs)
	if (locale === "ar") return ar_val_plot(inputs)
	if (locale === "id") return id_val_plot(inputs)
	if (locale === "it") return it_val_plot(inputs)
	if (locale === "ru") return ru_val_plot(inputs)
	if (locale === "pt") return pt_val_plot(inputs)
	return ko_val_plot(inputs)
});